import { Button } from '@99designs/common/components/Button';
import { default as BasePopoverCard } from '@99designs/common/components/PopoverCard/components/PopoverCard';
import { Color } from 'projects/consts';
import React from 'react';
import ColorComponent from './Color';

export interface Props {
    heading: string;
    message: string;
    storageKey: string;
    storageSource: Storage;
    selector?: string;
    color?: Color;
}

interface State {
    isDismissed: boolean;
}

export default class StoredPopoverCard extends React.Component<Props, State> {
    state = {
        isDismissed: false,
    };

    componentDidMount() {
        const { storageSource, storageKey } = this.props;
        this.setState({
            isDismissed: storageSource.getItem(storageKey) !== null,
        });
    }

    onDismiss() {
        const { storageSource, storageKey } = this.props;
        this.setState({ isDismissed: true });
        storageSource.setItem(storageKey, 'Got it');
    }

    render() {
        const { selector, heading, message, color } = this.props;
        const variations = [this.state.isDismissed ? 'hidden' : 'onboarding-prompt'];
        if (color === Color.squarespaceBlack) {
            variations.push('squarespace-black');
        }
        return (
            <BasePopoverCard
                layerSelector={selector}
                placement="top"
                variations={variations}
                card={
                    <ColorComponent color={color ? color : Color.pacificBlue}>
                        <h5 className="heading heading--h5">{heading}</h5>
                        <p className="paragraph paragraph--root">{message}</p>
                        <Button
                            variations={['primary', 'small', 'chameleon']}
                            onClick={() => this.onDismiss()}
                        >
                            {__('Got it')}
                        </Button>
                    </ColorComponent>
                }
            >
                <span>{this.props.children}</span>
            </BasePopoverCard>
        );
    }
}
